import { defineMessages } from 'react-intl';

export default defineMessages({
  pageNotFound: {
    id: 'global_page_not_found',
    defaultMessage: 'Page not found',
  },
  pageNotFoundMsg: {
    id: 'global_page_not_found_message',
    defaultMessage: "Sorry we can't find that page! It might be an old link or maybe it was moved.",
  },
  errorHasOccurred: {
    id: 'global_trovitAds_backoffice_applies_updateError',
    defaultMessage: 'An error has occurred',
  },
  goToHomepage: {
    id: 'alerts_feedbackfeedback_cancel_regards_action',
    defaultMessage: 'Go to the homepage',
  },
  noResults: {
    id: 'global_noresultados',
    defaultMessage: 'Your search did not match any result',
  },
  weSuggest: {
    id: 'global_noresultados_info',
    defaultMessage: 'We recommend the following:',
  },
  suggestion1: {
    id: 'global_noresultados_info1',
    defaultMessage: 'Check that you have correctly written all the words in your query.',
  },
  suggestion2: {
    id: 'global_noresultados_info2',
    defaultMessage: 'Check that you have correctly written all the words in your query.',
  },
});



// WEBPACK FOOTER //
// ./app/Error/messages.js